/* eslint-disable import/no-anonymous-default-export */
const d3 = require('d3')
const moment = require('moment');
const { parseDate } = require('../utils/formatters.js');
const { wrap, isInLimits } = require('../utils/shared-functions.js');
const { convertTimeToNum } = require('../utils/converter.js');
const { TRANSLATE_GENERAL_TAG } = require('../consts.js');
const TRANSLATE_TAG = 'charts.medications'
const VI_COLOR = '#58a63b';
const MEDICATION_TIME_COLOR = '#E9F0D8';
const MAX_DAY_HOUR = 24;
const MIN_DAY_HOUR = 4;
const TICKS_NUM = 20;
const margin = { top: 40, right: 30, bottom: 40, left: 50 };

exports.createMedicationsTakenCart = function (medicationsTaken, medicationsPerDay, width, height, translate) {
  const boxWidth = (width - margin.left - margin.right) / medicationsTaken.length
  const boxHeight = (height - margin.top - margin.bottom) / TICKS_NUM

  const data = []
  medicationsTaken.forEach((m) => {
    const date = parseDate(moment(m['date']).format('YYYY-MM-DD'));
    const currentData = m['medication_taken_data']
    const obj = {
      date,
    };
    const dayMedications = getDayMedications(date)
    if(dayMedications.length){
      dayMedications.forEach((d) => {
        const medicineTime = Math.floor(convertTimeToNum(d.time, 'HH:mm'))
        const nestedObj = {date, medicineTime}
        data.push(nestedObj)
      })
    }
    if (currentData?.length) {
      currentData.forEach((c) => {
        const takenTime = convertTimeToNum(c.timestamp)
        const nestedObj = {date, takenTime}
        data.push(nestedObj)
      })
    } else {
      data.push(obj)
    }
  });

  const x = d3.scaleBand()
    .domain(d3.utcDay.range(data[0].date, +data[data.length - 1].date + 1))
    .range([margin.left, width - margin.right])
    .padding(0.4);

  const y = d3.scaleLinear()
    .domain([MIN_DAY_HOUR, MAX_DAY_HOUR])
    .nice()
    .range([height - margin.bottom, margin.top]);

  const xAxis = (g) =>
    g.attr('transform', `translate(0,${height - margin.bottom - 2})`)
      .call(d3.axisBottom(x)
        .tickValues(d3.utcDay.every(1).range(data[0].date, +data[data.length - 1].date + 1))
        .tickFormat((d) => moment(d).format('ddd DD'))
        .tickSize(0)
      )
      .call((g) =>
        g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('transform', `translate(0,${-height + margin.top + margin.bottom + 3})`)
          .attr('y2', height - margin.top - margin.bottom)
      )
      .call((g) => g.select('.domain').remove());

  const yAxis = (g) =>
    g.attr('transform', `translate(${margin.left},0)`)
      .call(d3.axisLeft(y)
        .ticks(TICKS_NUM)
        .tickFormat((d) => (d % 4 === 0 && d > 4) ? moment({ hour: d }).format('HH:mm') : '')
        .tickSize(0)
        .tickPadding(10)
      )
      .call((g) =>
        g.selectAll('.tick line')
          .clone()
          .attr('stroke-opacity', 0.2)
          .attr('x2', width - margin.left - margin.right)
      )
      .call((g) => g.select('.domain').remove());

  function drawViSign(group) {
    group.append('line')
      .attr('x1', -5)
      .attr('x2', -2)
      .attr('y1', 2)
      .attr('y2', 5)

      .attr('stroke-linecap', 'round')
      .attr('stroke-linejoin', 'round')
      .attr('stroke', VI_COLOR)
      .attr('stroke-width', 2);

    group.append('line')
      .attr('x1', -2)
      .attr('x2', 5)
      .attr('y1', 5)
      .attr('y2', -3)
      .attr('stroke', VI_COLOR)

      .attr('stroke-linecap', 'round')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-width', 2);
  }

  const svg = d3
    .create('svg')
    .attr('width', width)
    .attr('height', height);

  const medicationTimeBar = svg.append('g')
  .selectAll('g')
  .data(data)
  .join('g')
  .filter((d) => d.medicineTime)
  .attr('transform', (d) => `translate(${x(d.date)},0)`)
  .append('rect')
  .attr('width', boxWidth)
  .attr('height', boxHeight)
  .attr('y', (d) => y(d.medicineTime + 1))
  .attr('x', -((boxWidth - x.bandwidth()) / 2))
  .attr('fill', MEDICATION_TIME_COLOR)

  svg.append('g').call(xAxis).selectAll('.tick text').call(wrap, x.bandwidth());
  svg.append('g').call(yAxis);

  const xAxisLabelDate = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 20)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.date`) : 'Date');

  const xAxisLabelDay = svg
    .append('text')
    .attr('x', 20)
    .attr('y', height - margin.bottom + 33)
    .style('font-size', '12px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_GENERAL_TAG}.general_words.day`) : 'Day');

    const g = svg
    .append('g')
    .selectAll('g')
    .data(data)
    .join('g')
    .attr('transform', (d) => `translate(${x(d.date)},0)`);  

  const takenCandleGroup = g.append('g')
    .filter((d) => isInLimits(d.takenTime, MIN_DAY_HOUR, MAX_DAY_HOUR))
    .attr('transform', (d) => `translate(${x.bandwidth() / 2},${y(d.takenTime)})`);

  const takenCircle = takenCandleGroup
    .append('circle')
    .attr('r', 10)
    .attr('stroke-width', 2)
    .attr('fill', '#fff')
    .attr('stroke', VI_COLOR)
    // .style("cursor", "pointer")
    // .on("click", (e, d) => onClick(d.date));

    takenCandleGroup.call(drawViSign);

    
  const gLegend = svg.append('g').attr('transform', `translate(${margin.left}, ${margin.top - 25})`);
 
  const reminderRect = gLegend
    .append('rect')
    .attr('x', 0)
    .attr('y', 0)
    .attr('width', 16)
    .attr('height', 16)
    .attr('fill', MEDICATION_TIME_COLOR);

  const reminderLegendText = gLegend
    .append('text')
    .attr('x', 25)
    .attr('y', margin.top - 25)
    .style('font-size', '17px')
    .attr('font-weight', '100')
    .text(translate ? translate(`${TRANSLATE_TAG}.med_reminder`) : 'Medications reminder');
     
  const takenLegendCircle = gLegend
  .append('circle')
  .attr('cx', 230)
  .attr('cy', margin.top - 31)
  .attr('r', 9)
  .attr('stroke-width', 2)
  .attr('fill', 'white')
  .attr('stroke', VI_COLOR);

const takenLegendVi = gLegend.append('g')
  .attr('transform', `translate(230, ${margin.top - 31})`)
  .call(drawViSign);

const takenLegendText = gLegend
  .append('text')
  .attr('x', 248)
  .attr('y', margin.top - 25)
  .style('font-size', '17px')
  .attr('font-weight', '100')
  .text(translate ? translate(`${TRANSLATE_TAG}.taken`) : 'Taken');


  return svg.node();
  
  function getDayMedications(date) {
    let dayMedications = medicationsPerDay.everyDay
    const weekDay = moment(date).day() + 1
    dayMedications = [...dayMedications, ...medicationsPerDay[weekDay]]
    return dayMedications
  }

}

